// removed by extract-text-webpack-plugin
module.exports = {"sm":"only screen and (min-width: 48em)","md":"only screen and (min-width: 64em)","lg":"only screen and (min-width: 75em)","friendSearchContainer":"friendSearchContainer-6E2dJ","pendingFriendsContainer":"pendingFriendsContainer-1MKj1","searchBar":"searchBar-2gj2W","searchInput":"searchInput-1EPCT","searchButton":"searchButton-167h7","searchValidationMessage":"searchValidationMessage-1U8Yf","noSearchResults":"noSearchResults-Ae563","moreSuggestedFriendsButton":"moreSuggestedFriendsButton-1O9Q5"};


//////////////////
// WEBPACK FOOTER
// ./src/components/friends/_findFriends.css
// module id = 1196
// module chunks = 1